import {
  CREATE_RELAY_LOAD,
  DELETE_RELAY_LOAD,
  EDIT_RELAY_LOAD,
  RECEIVE_RELAYLOADS,
  REQUEST_SITE_GROUP_RELAYLOADS,
  REQUEST_SITE_RELAYLOADS,
} from '@sophocles/entities/RelayLoad/relayLoadActions';
import { Map } from 'immutable';

function getState(state = Map(), action) {
  switch (action.type) {
    case RECEIVE_RELAYLOADS:
      return state.merge(action.relayLoads);
    case DELETE_RELAY_LOAD:
      return state.delete(action.relayLoad.toString());
    case REQUEST_SITE_GROUP_RELAYLOADS:
    case REQUEST_SITE_RELAYLOADS:
    case EDIT_RELAY_LOAD:
    case CREATE_RELAY_LOAD:
    default:
      return state;
  }
}

export function relayLoadReducer(state = Map(), action) {
  switch (action.type) {
    case REQUEST_SITE_RELAYLOADS:
    case REQUEST_SITE_GROUP_RELAYLOADS:
    case RECEIVE_RELAYLOADS:
    case EDIT_RELAY_LOAD:
    case CREATE_RELAY_LOAD:
    case DELETE_RELAY_LOAD:
      return getState(state, action);
    default:
      return state;
  }
}
